
const colorThemes = {
  blue:    { accent: '#3b82f6', bg: 'linear-gradient(135deg, #0d2030 0%, #0a1628 100%)' },
  teal:    { accent: '#0e7a6e', bg: 'linear-gradient(135deg, #0d2a2a 0%, #0a1f2c 100%)' },
  purple:  { accent: '#7c3aed', bg: 'linear-gradient(135deg, #2a1135 0%, #1a0a25 100%)' },
  green:   { accent: '#10b981', bg: 'linear-gradient(135deg, #0e2a1f 0%, #0a1e18 100%)' },
  amber:   { accent: '#d97706', bg: 'linear-gradient(135deg, #2c1d10 0%, #1f140a 100%)' },
  red:     { accent: '#ef4444', bg: 'linear-gradient(135deg, #2c1010 0%, #1f0a0a 100%)' },
  pink:    { accent: '#ec4899', bg: 'linear-gradient(135deg, #2c1024 0%, #1f0a18 100%)' },
  rose:    { accent: '#f43f5e', bg: 'linear-gradient(135deg, #2c1018 0%, #1f0a10 100%)' },
  indigo:  { accent: '#6366f1', bg: 'linear-gradient(135deg, #14182c 0%, #0a0e1f 100%)' },
  cyan:    { accent: '#06b6d4', bg: 'linear-gradient(135deg, #0a2a30 0%, #0a1e22 100%)' },
  sky:     { accent: '#0ea5e9', bg: 'linear-gradient(135deg, #0a2030 0%, #0a1525 100%)' },
  fuchsia: { accent: '#d946ef', bg: 'linear-gradient(135deg, #2c1030 0%, #1f0a25 100%)' },
  orange:  { accent: '#f97316', bg: 'linear-gradient(135deg, #2c1810 0%, #1f100a 100%)' },
  lime:    { accent: '#84cc16', bg: 'linear-gradient(135deg, #1f2a10 0%, #161f0a 100%)' },
  emerald: { accent: '#059669', bg: 'linear-gradient(135deg, #0a2820 0%, #061d18 100%)' },
  slate:   { accent: '#64748b', bg: 'linear-gradient(135deg, #1a2333 0%, #10141d 100%)' },
};

// Build a theme for any value: preset key OR hex string like "#ff00aa"
const themeForColor = (color) => {
  if (!color) return colorThemes.blue;
  if (color.startsWith('#')) {
    return { accent: color, bg: `linear-gradient(135deg, ${color}22 0%, #0a1628 100%)` };
  }
  return colorThemes[color] || colorThemes.blue;
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const COURSE_COLOR_PRESETS = colorThemes;

export const mapApiCourse = (x) => {
  const theme = themeForColor(x.color);
  const coverUrl = x.cover ? (x.cover.startsWith('/api/') ? `${BACKEND_URL}${x.cover}` : x.cover) : 'https://images.pexels.com/photos/8438967/pexels-photo-8438967.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';
  return {
    id: x.id,
    brand: { ar: x.brandAr || '', en: x.brandEn || '' },
    title: { ar: x.titleAr, en: x.titleEn },
    subtitle: { ar: x.subtitleAr || '', en: x.subtitleEn || '' },
    level: { ar: x.levelAr || '', en: x.levelEn || '' },
    hours: x.hours || 0,
    seconds: x.total_seconds || 0,
    students: x.students || 0,
    created_at: x.created_at || '',
    color: x.color || 'blue',
    accent: theme.accent,
    bg: theme.bg,
    image: coverUrl,
    description: { ar: x.descriptionAr || '', en: x.descriptionEn || '' },
    youtube: x.youtube || '',
    video_url: x.video_url ? (x.video_url.startsWith('/api/') ? `${BACKEND_URL}${x.video_url}` : x.video_url) : '',
    categories: Array.isArray(x.categories) ? x.categories : [],
    learn: (x.learnAr || []).map((ar, i) => ({ ar, en: (x.learnEn || [])[i] || ar })),
    published: x.published !== false,
    featured: !!x.featured,
    show_home: x.show_home !== false,
    is_free: !!x.is_free,
    has_video: !!(x.has_video || x.youtube || x.video_url),
    lessons: (x.lessons || []).map(l => ({
      id: l.id,
      title: { ar: l.titleAr, en: l.titleEn },
      youtube: l.youtube || '',
      video_url: l.video_url ? (l.video_url.startsWith('/api/') ? `${BACKEND_URL}${l.video_url}` : l.video_url) : '',
      duration_min: l.duration_min || 0,
      duration_sec: l.duration_sec || 0,
      order: l.order || 0,
      is_free: !!x.is_free || !!l.is_free,
      locked: !!l.locked,
      section_id: l.section_id || '',
      description: { ar: l.descriptionAr || '', en: l.descriptionEn || '' },
      learn: (l.learnAr || []).map((ar, i) => ({ ar, en: (l.learnEn || [])[i] || ar })),
      outline: (l.outlineAr || []).map((ar, i) => ({ ar, en: (l.outlineEn || [])[i] || ar })),
      quiz_id: l.quiz_id || '',
      type: l.type || 'video',
      content: { ar: l.contentAr || '', en: l.contentEn || l.contentAr || '' },
      article_id: l.article_id || '',
      article: l.article || null,
      attachments: l.attachments || [],
    })).sort((a, b) => (a.order - b.order)),
    sections: (x.sections || []).map(s => ({ id: s.id, title: { ar: s.titleAr, en: s.titleEn || s.titleAr }, order: s.order || 0 })).sort((a, b) => a.order - b.order),
  };
};

export const getMergedCourses = (apiCourses, { includeDrafts = false } = {}) => {
  const mapped = (apiCourses || []).map(mapApiCourse).filter(c => includeDrafts || c.published);
  return mapped;
};
